import type { RootState } from 'app/store';

export const selectParametersSettingsLanguage = (state: RootState) =>
    state.parametersSettings.language;
export const selectParametersSettingConfigPath = (state: RootState) =>
    state.parametersSettings.configPath;
